import('./pb-quotescarousel.css');
const slick = require("slick-carousel");
const slickCSS = require("slick-carousel/slick/slick.css");

const pbQuotesCarousel = {
    init: function () {
        let carousels = [];
        let carIdx = 0;
        
        $('.pb-quotescarousel').find('.pb-carousel').each(function() {
            let self = $(this);
            
            carousels[carIdx] = $(this).slick({
                // slidesToShow: 4,
                slidesToScroll: 1,
                infinite: false,
                dots: true,
                arrows: false,
                variableWidth: false
            }); 


            carIdx++;
        });
        
    }

}

window.loadedComponents.push({ component: 'pb-quotescarousel', init: pbQuotesCarousel.init});

export default() => {
    pbQuotesCarousel.init();
}